<template>
<MainLayout selectMenu="3-1">
    <div v-if="!hasAuth">
        <NoAuth></NoAuth>
    </div>
    <div v-else>
        <WebSocket :url="webSocketUrl" @receive-message="receiveMessage"></WebSocket>
        <input type="text" name="username" style="display:none" /><!-- 防止浏览器自动填充用户名密码 -->
        <input type="password" name="password" style="display:none" /><!-- 防止浏览器自动填充用户名密码 -->
        <Row class="menu-line" type="flex">
            <Col flex="12" class="menu-actions ">
            <div class="action-groups">
                <div class="action-group">
                    <legend>
                        <Button type="primary" icon="md-add" size="small" @click.native="add()">{{ getTranslation('m005')
                }}</Button>&nbsp;
                        <Upload :action="importUrl" name="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :show-upload-list="false" class="flex-middle" :on-success="successImport" :on-error="errorImport"><Button type="success" icon="md-cloud-upload" size="small">{{ getTranslation('m154') }}</Button></Upload>&nbsp;
                        <Button type="info" icon="md-cloud-download" size="small" @click.native="exportData()">{{
                getTranslation('m155') }}</Button>
                        &nbsp;
                        <Button type="success" icon="ios-cloud-upload-outline" size="small" @click.native="upgrade()">{{
                getTranslation('k115') }}</Button>
                    </legend>
                </div>
                <div class="action-group">
                    <legend>
                        <Button type="warning" icon="md-swap" size="small" @click.native="backup()">{{ getTranslation('m152')
                }}</Button>
                        &nbsp;
                        <Button type="error" icon="ios-refresh" size="small" @click.native="revert()">{{ getTranslation('m153')
                }}</Button>
                    </legend>
                </div>

                <div class="action-group">
                    <legend>
                        <Button type="primary" icon="ios-refresh" size="small" @click.native="spotRefresh()">{{
                getTranslation('d029') }}</Button>
                    </legend>
                </div>
            </div>
            </Col>
            <Col flex="12" class="search-part">
            <Button type="info" size="small" icon="md-funnel" @click="colShowVisible = true">{{ getTranslation('u113')
          }}</Button>&nbsp;
            {{ getTranslation('m012') }}&nbsp;
            <Select :transfer="true" size="small" v-model="selectProductline" :filterable="true" :placeholder="getTranslation('m034')" style="width:15%" @on-change="search()">
                <Option :value="0" key="0">{{ getTranslation('m032') }}</Option>
                <Option v-for="item in productline" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>&nbsp;
            <Select :transfer="true" size="small" v-model="selectState" :placeholder="getTranslation('m033')" style="width:15%" @on-change="search()">
                <Option v-for="item in stateList" :value="item.value" :key="item.value">{{ item.name }}</Option>
            </Select>&nbsp;

            <Input v-model="kw" size="small" style="width:30%" :placeholder="getTranslation('m075')" @on-enter="search()" />&nbsp;

            <Input v-model="controllerSwVersion" name="something-else" type="text" size="small" autocomplete="nope" style="width:150px" :placeholder="getTranslation('r024')" @on-enter="search()" />&nbsp;
            <Tooltip :content="getTranslation('k176')" placement="bottom" theme="light" :transfer="true">
                <Button type="primary" @click.native="search()" size="small" shape="circle" icon="ios-search"></Button>
            </Tooltip>
            &nbsp;
            <Tooltip :content="getTranslation('e020')" placement="bottom" theme="light" :transfer="true">
                <Button type="error" size="small" @click.native="emptyQuery()" shape="circle" icon="ios-refresh"></Button>
            </Tooltip>
            </Col>
        </Row>
        <template v-if="upgrading">
            <div class="upgrade-progress-container">
                <!-- 总体进度区域 -->
                <div class="overall-progress-section">
                    <div class="progress-header">
                        <h3 class="progress-title">{{ getTranslation('m121') }}</h3>
                    </div>
                    <div class="progress-content">
                        <div class="main-progress">
                            <div class="circle-progress">
                                <div ref="upgradeProgressChart" class="upgrade-progress-pie"></div>
                            </div>
                            <div class="progress-content-right">
                                <div class="stats-row">
                                    <div class="stat-item">
                                        <span class="stat-label">{{ getTranslation('m089') }}：</span>
                                        <span class="stat-value total">{{ calUpgradeTotal }}</span>
                                    </div>
                                    <div class="stat-item">
                                        <span class="stat-label">{{ getTranslation('m122') }}：</span>
                                        <span class="stat-value success">{{ calUpgradeSuccess }}</span>
                                    </div>
                                    <div class="stat-item">
                                        <span class="stat-label">{{ getTranslation('m123') }}</span>
                                        <span class="stat-value failed">{{ calUpgradeFailed }}</span>
                                    </div>
                                    <div class="stat-item">
                                        <span class="stat-label">{{ getTranslation('m124') }}</span>
                                        <span class="stat-value processing">{{ calUpgradeTotal - calUpgradeSuccess - calUpgradeFailed
                      }}</span>
                                    </div>
                                </div>
                                <div class="button-row">
                                    <Button @click="upgrading = false" :disabled="!canClose" type="primary" size="small" icon="md-close">{{ getTranslation('k048') }}</Button>
                                    <Button v-if="canRetry" type="success" size="small" @click.native="retry()" icon="ios-refresh">{{
                      getTranslation('m119') }}</Button>
                                    <template v-if="canceling && !canClose">
                                        <div class="canceling-status">
                                            <div class="canceling-spinner">
                                                <div class="spinner-circle"></div>
                                            </div>
                                            <span class="canceling-text">{{ getTranslation('m129') }}</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <Button v-if="canCancel" type="warning" @click.native="cancel()" size="small" icon="md-close-circle">{{ getTranslation('b182') }}</Button>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 设备详细进度 -->
                <div class="device-progress-section">
                    <div class="device-header">
                        <h3 class="device-title">{{ getTranslation('m125') }}</h3>
                    </div>
                    <div class="device-list">
                        <div v-for="(oneProgress, keyProgress) in listOfProgress" :key="keyProgress" class="device-item">
                            <div class="device-row">
                                <!-- 设备信息 -->
                                <div class="device-info">
                                    <div class="device-name">
                                        <span class="device-icon">📱</span>
                                        {{ oneProgress.mac_name }}
                                    </div>
                                    <div class="device-status" :class="getStatusClass(oneProgress.status)">
                                        {{ mapStatus[oneProgress.status] }}
                                    </div>
                                </div>

                                <!-- 进度信息 -->
                                <div class="device-progress-info">
                                    <div class="progress-bar">
                                        <Progress text-inside :percent="calOnePercent(oneProgress)" :stroke-width="16" :stroke-color="getProgressColor(oneProgress.status)" :status="getProgressStatus(oneProgress.status)">
                                        </Progress>
                                    </div>
                                    <div class="progress-count">
                                        {{ oneProgress.processed }}/{{ oneProgress.total }}
                                    </div>
                                </div>
                            </div>

                            <!-- 错误信息（单独一行） -->
                            <div class="device-error" v-if="oneProgress.error">
                                <div class="error-message">
                                    <span class="error-icon">⚠️</span>
                                    {{ oneProgress.error }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="backuping">
            <div class="upgrade-progress-container">
                <!-- 总体进度区域 -->
                <div class="overall-progress-section">
                    <div class="progress-header">
                        <h3 class="progress-title"><template v-if="paramyType == 'backup'">{{ getTranslation('m164') }}</template>
                            <template v-else-if="paramyType == 'revert'">{{ getTranslation('m182') }}</template>
                            <template v-else>{{ getTranslation('d035') }}</template>
                        </h3>
                    </div>
                    <div class="progress-content">
                        <div class="main-progress">
                            <div class="circle-progress">
                                <div ref="backupProgressChart" class="upgrade-progress-pie"></div>
                            </div>
                            <div class="progress-content-right">
                                <div class="stats-row">
                                    <div class="stat-item">
                                        <span class="stat-label">{{ getTranslation('m089') }}：</span>
                                        <span class="stat-value total">{{ calBackupTotal }}</span>
                                    </div>
                                    <div class="stat-item">
                                        <span class="stat-label">{{ getTranslation('m122') }}：</span>
                                        <span class="stat-value success">{{ calBackupSuccess }}</span>
                                    </div>
                                    <div class="stat-item">
                                        <span class="stat-label">{{ getTranslation('m123') }}</span>
                                        <span class="stat-value failed">{{ calBackupFailed }}</span>
                                    </div>
                                    <div class="stat-item">
                                        <span class="stat-label">{{ getTranslation('m124') }}</span>
                                        <span class="stat-value processing">{{ calBackupTotal - calBackupSuccess - calBackupFailed
                      }}</span>
                                    </div>
                                </div>
                                <div class="button-row">
                                    <Button @click="closeBackup()" :disabled="!canBackupClose" type="primary" size="small" icon="md-close">{{
                      getTranslation('k048') }}</Button>

                                    <Button v-if="canBackupRetry" type="success" size="small" @click.native="retryBackup()" icon="ios-refresh">{{
                      getTranslation('m119') }}</Button>

                                    <template v-if="backupCanceling && !canBackupClose">
                                        <div class="canceling-status">
                                            <div class="canceling-spinner">
                                                <div class="spinner-circle"></div>
                                            </div>
                                            <span class="canceling-text">{{ getTranslation('m129') }}</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <Button v-if="canBackupCancel" type="warning" @click.native="cancelBackup()" size="small" icon="md-close-circle">{{ getTranslation('b182') }}</Button>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 设备详细进度 -->
                <div class="device-progress-section">
                    <div class="device-header">
                        <h3 class="device-title">
                            <template v-if="paramyType == 'backup'">{{ getTranslation('m165') }}</template>
                            <template v-else-if="paramyType == 'revert'">{{ getTranslation('m183') }}</template>
                            <template v-else>{{ getTranslation('d036') }}</template>
                        </h3>
                    </div>
                    <div class="device-list">
                        <div v-for="(oneProgress, keyProgress) in listOfBackupProgress" :key="keyProgress" class="device-item">
                            <div class="device-row">
                                <!-- 设备信息 -->
                                <div class="device-info">
                                    <div class="device-name">
                                        <span class="device-icon">📱</span>
                                        {{ oneProgress.mac_name }}
                                    </div>
                                    <div class="device-status" :class="getBackupStatusClass(oneProgress.status)">
                                        {{ mapBackupStatus[oneProgress.status] }}
                                    </div>
                                </div>

                                <!-- 进度信息 -->
                                <div class="progress-group">
                                    <div class="device-progress-info" v-if="oneProgress.list_progress && oneProgress.list_progress['prog']">

                                        <div class="progress-bar online-part">
                                            <Progress text-inside :percent="calOnePercent(oneProgress.list_progress['prog'])" :stroke-width="16" :stroke-color="getProgressColor(oneProgress.status)" :status="getProgressStatus(oneProgress.status)">
                                            </Progress>
                                        </div>
                                        <div class="progress-count">
                                            <template v-if="paramyType == 'backup'">{{ getTranslation('m170') }}</template>
                                            <template v-else-if="paramyType == 'revert'">{{ getTranslation('m187') }}</template>
                                            <template v-else>{{ getTranslation('d037') }}</template>
                                            :{{ oneProgress.list_progress['prog'].processed }}/{{ oneProgress.list_progress['prog'].total }}
                                        </div>

                                    </div>

                                    <div class="device-progress-info" v-if="oneProgress.list_progress && oneProgress.list_progress['sys']">
                                        <div class="progress-bar">
                                            <Progress text-inside :percent="calOnePercent(oneProgress.list_progress['sys'])" :stroke-width="16" :stroke-color="getProgressColor(oneProgress.status)" :status="getProgressStatus(oneProgress.status)">
                                            </Progress>
                                        </div>
                                        <div class="progress-count">
                                            <template v-if="paramyType == 'backup'">{{ getTranslation('m171') }}</template>
                                            <template v-else-if="paramyType == 'revert'">{{ getTranslation('m188') }}</template>
                                            <template v-else>{{ getTranslation('d037') }}</template>
                                            :{{ oneProgress.list_progress['sys'].processed }}/{{ oneProgress.list_progress['sys'].total }}
                                        </div>
                                    </div>

                                    <div class="device-progress-info" v-if="oneProgress.list_progress && oneProgress.list_progress['spot']">
                                        <div class="progress-bar">
                                            <Progress text-inside :percent="calOnePercent(oneProgress.list_progress['spot'])" :stroke-width="16" :stroke-color="getProgressColor(oneProgress.status)" :status="getProgressStatus(oneProgress.status)">
                                            </Progress>
                                        </div>
                                        <div class="progress-count">
                                            <template v-if="paramyType == 'backup'">{{ getTranslation('m172') }}</template>
                                            <template v-else-if="paramyType == 'revert'">{{ getTranslation('m189') }}</template>
                                            <template v-else>{{ getTranslation('d037') }}</template>
                                            :{{ oneProgress.list_progress['spot'].processed }}/{{ oneProgress.list_progress['spot'].total }}
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <!-- 错误信息（单独一行） -->
                            <div class="device-error" v-if="oneProgress.error">
                                <div class="error-message">
                                    <span class="error-icon">⚠️</span>
                                    {{ oneProgress.error }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div>
                <div v-if="machineWarning" class="machine-warning">
                    <Row type="flex">
                        <Col flex="1">
                        <div v-html="safeMachineWarning"></div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1">
                        <Button type="info" icon="md-cloud-download" size="small" @click.native="exportWarning()">{{
              getTranslation('k025') }}</Button>
                        </Col>
                    </Row>
                </div>
                <Affix>
                    <Row class="table-header" type="flex" style="flex-wrap: nowrap;overflow: visible !important;">
                        <Col flex="1" class="table-cell flex-left" :style="colStyle('1')" ref="col-ref-1" v-show="showCol('1')">
                        &nbsp;<Checkbox @on-change="handleCheckAll">
                        </Checkbox>
                        <span class="sortable">
                            {{ getTranslation('m008') }}
                        </span>
                        <span class="col-resizer" @mousedown="startResize('1', $event)"></span>
                        </Col>
                        <Col flex="1" class="table-cell" :style="colStyle('2')" ref="col-ref-2" v-show="showCol('2')">
                        <span>{{ getTranslation('m009') }}</span>
                        <span class="col-resizer" @mousedown="startResize('2', $event)"></span>
                        </Col>
                        <Col flex="3" class="table-cell" :style="colStyle('3')" ref="col-ref-3" v-show="showCol('3')">
                        <span class="sortable" @click.stop="toggleSort('code')">
                            {{ getTranslation('m010') }}
                            <template v-if="sortKey !== 'code'">
                                <img class="sort-img" src="@/assets/img/sort-1.png" />
                            </template>
                            <template v-else>
                                <Icon :type="sortKey === 'code' ? (sortOrder === 'asc' ? 'md-arrow-up' : 'md-arrow-down') : 'md-swap'" class="sort-icon" />
                            </template>
                        </span>
                        <span class="col-resizer" @mousedown="startResize('3', $event)"></span>
                        </Col>
                        <Col flex="2" class="table-cell" :style="colStyle('4')" ref="col-ref-4" v-show="showCol('4')">
                        <span class="sortable" @click.stop="toggleSort('controller_sw_ver')">
                            {{ getTranslation('r024') }}
                            <template v-if="sortKey !== 'controller_sw_ver'">
                                <img class="sort-img" src="@/assets/img/sort-1.png" />
                            </template>
                            <template v-else>
                                <Icon :type="sortKey === 'controller_sw_ver' ? (sortOrder === 'asc' ? 'md-arrow-up' : 'md-arrow-down') : 'md-swap'" class="sort-icon" />
                            </template>
                        </span>
                        <span class="col-resizer" @mousedown="startResize('4', $event)"></span>
                        </Col>
                        <Col flex="3" class="table-cell" :style="colStyle('5')" ref="col-ref-5" v-show="showCol('5')">
                        <span>
                            {{ getTranslation('m011') }}
                        </span>
                        <span class="col-resizer" @mousedown="startResize('5', $event)"></span>
                        </Col>
                        <Col flex="3" class="table-cell" :style="colStyle('6')" ref="col-ref-6" v-show="showCol('6')">
                        <span>{{ getTranslation('m012') }}</span>
                        <span class="col-resizer" @mousedown="startResize('6', $event)"></span>
                        </Col>
                        <Col flex="1" class="table-cell" :style="colStyle('7')" ref="col-ref-7" v-show="showCol('7')">
                        <span class="sortable" @click.stop="toggleSort('seq')">
                            {{ getTranslation('m013') }}
                            <template v-if="sortKey !== 'seq'">
                                <img class="sort-img" src="@/assets/img/sort-1.png" />
                            </template>
                            <template v-else>
                                <Icon :type="sortKey === 'seq' ? (sortOrder === 'asc' ? 'md-arrow-up' : 'md-arrow-down') : 'md-swap'" class="sort-icon" />
                            </template>
                        </span>
                        <span class="col-resizer" @mousedown="startResize('7', $event)"></span>
                        </Col>
                        <Col flex="2" class="table-cell" :style="colStyle('8')" ref="col-ref-8" v-show="showCol('8')">
                        <span class="sortable" @click.stop="toggleSort('address')">{{ getTranslation('m014') }}
                            <template v-if="sortKey !== 'address'">
                                <img class="sort-img" src="@/assets/img/sort-1.png" />
                            </template>
                            <template v-else>
                                <Icon :type="sortKey === 'address' ? (sortOrder === 'asc' ? 'md-arrow-up' : 'md-arrow-down') : 'md-swap'" class="sort-icon" />
                            </template>
                        </span>
                        <span class="col-resizer" @mousedown="startResize('8', $event)"></span>
                        </Col>
                        <Col flex="2" class="table-cell" :style="colStyle('9')" ref="col-ref-9" v-show="showCol('9')">
                        <span class="sortable">{{ getTranslation('m213') }}
                        </span>
                        <span class="col-resizer" @mousedown="startResize('9', $event)"></span>
                        </Col>
                        <Col flex="2" class="table-cell" :style="colStyle('10')" ref="col-ref-10" v-show="showCol('10')">
                        <span class="sortable" @click.stop="toggleSort('controller_boot_ver')">
                            {{ getTranslation('r026') }}
                            <template v-if="sortKey !== 'controller_boot_ver'">
                                <img class="sort-img" src="@/assets/img/sort-1.png" />
                            </template>
                            <template v-else>
                                <Icon :type="sortKey === 'controller_boot_ver' ? (sortOrder === 'asc' ? 'md-arrow-up' : 'md-arrow-down') : 'md-swap'" class="sort-icon" />
                            </template>
                        </span>
                        <span class="col-resizer" @mousedown="startResize('10', $event)"></span>
                        </Col>
                        <Col flex="3" class="table-cell" :style="colStyle('11')" ref="col-ref-11" v-show="showCol('11')">
                        <span>
                            {{ getTranslation('m016') }}
                        </span>
                        <span class="col-resizer" @mousedown="startResize('11', $event)"></span>
                        </Col>
                        <Col flex="2" class="table-cell" :style="colStyle('12')" ref="col-ref-12" v-show="showCol('12')">
                        <span>{{ getTranslation('m017') }}</span>
                        <span class="col-resizer" @mousedown="startResize('12', $event)"></span>
                        </Col>
                        <Col flex="2" class="table-cell" :style="colStyle('13')" ref="col-ref-13" v-show="showCol('13')">
                        <span>{{ getTranslation('m018') }}</span>
                        <span class="col-resizer" @mousedown="startResize('13', $event)"></span>
                        </Col>
                    </Row>
                </Affix>

                <CheckboxGroup v-model="selectedItems">
                    <Row v-for="(item, index) in machine" :key="item.id" style="flex-wrap: nowrap;overflow: visible !important;" :class="['table-row', index % 2 === 0 ? 'table-row-even' : 'table-row-odd']" type="flex" @click.native="switchCheckbox(item)">
                        <Col flex="1" class="table-cell" :style="colStyle('1')" v-show="showCol('1')">&nbsp;<Checkbox class="hide-label" :label="item.id"></Checkbox>{{ item.id
              }}
                        </Col>
                        <Col flex="1" :class="['table-cell', { 'online': item.state == 1 }]" :style="colStyle('2')" v-show="showCol('2')">{{
                stateMap[item.state] }}
                        <Tooltip :content="getTranslation('m001')" placement="bottom" theme="light" :transfer="true" v-if="KindOf803Series(item.kind) && (item.state == 1 || item.state == 2)">
                            &nbsp;<Button type="warning" icon="md-link" size="small" @click.native.stop="offline(item.id)"></Button>
                        </Tooltip>
                        <Tooltip :content="getTranslation('m002')" placement="bottom" theme="light" :transfer="true" v-if="KindOf803Series(item.kind) && item.state == 0">
                            &nbsp;<Button type="success" icon="md-link" size="small" @click.native.stop="online(item.id)"></Button>
                        </Tooltip>

                        </Col>
                        <Col flex="3" class="table-cell" :style="colStyle('3')" v-show="showCol('3')">{{ item.code }}
                        </Col>
                        <Col flex="2" class="table-cell" :style="colStyle('4')" v-show="showCol('4')"><template v-if="item.controller_sw_ver">V{{ item.controller_sw_ver
              }}</template>
                        </Col>
                        <Col flex="3" class="table-cell" :style="colStyle('5')" v-show="showCol('5')">{{ item.name }}
                        </Col>
                        <Col flex="3" class="table-cell" :style="colStyle('6')" v-show="showCol('6')">{{ mapProductLine[item.pl_id]
            }}
                        </Col>
                        <Col flex="1" class="table-cell" :style="colStyle('7')" v-show="showCol('7')">{{ item.seq }}
                        </Col>
                        <Col flex="2" class="table-cell" :style="colStyle('8')" v-show="showCol('8')">{{ item.address }}:{{
              item.port }}
                        </Col>
                        <Col flex="2" class="table-cell" :style="colStyle('9')" v-show="showCol('9')">{{ item.mac }}
                        </Col>
                        <Col flex="2" class="table-cell" :style="colStyle('10')" v-show="showCol('10')"><template v-if="item.controller_boot_ver">V_{{ item.controller_boot_ver
              }}</template>
                        </Col>
                        <Col flex="3" class="table-cell" :style="colStyle('11')" v-show="showCol('11')">{{ item.remark }}
                        </Col>
                        <Col flex="2" class="table-cell" :style="colStyle('12')" v-show="showCol('12')">{{ item.updated_string }}
                        </Col>
                        <Col flex="2" class="table-cell action-buttons flex-middle" :style="colStyle('13')" v-show="showCol('13')">
                        <Tooltip :content="getTranslation('m019')" placement="bottom" theme="light" :transfer="true">
                            <Button size="small" type="primary" icon="md-create" @click.native.stop="edit(item.id)"></Button>
                        </Tooltip>
                        <Tooltip :content="getTranslation('m027')" placement="bottom" theme="light" :transfer="true" v-if="item.state != 3">
                            <Button size="small" type="error" icon="md-trash" v-if="item.state != 3" @click.native.stop="del(item.id)"></Button>
                        </Tooltip>
                        <Tooltip :content="getTranslation('m028')" placement="bottom" theme="light" :transfer="true" v-if="item.state == 3">
                            <Button size="small" type="success" icon="md-refresh" v-if="item.state == 3" @click.native.stop="recovery(item.id)"></Button>
                        </Tooltip>
                        <!--<Tooltip :content="getTranslation('i032')" placement="bottom" theme="light" :transfer="true" v-if="item.state == 3">
              <Button size="small" type="error" icon="md-trash" v-if="item.state == 3"
                @click.native.stop="realDel(item.id)"></Button>
            </Tooltip>
            -->
                        <Tooltip :content="getTranslation('b033')" placement="bottom" theme="light" :transfer="true">
                            <Button size="small" type="warning" icon="md-copy" @click.native.stop="copy(item.id)"></Button>
                        </Tooltip>
                        </Col>
                    </Row>
                </CheckboxGroup>
                <Page class="page-line" :total="total" :current="current" :page-size="pageSize" show-total @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange" :show-sizer="true" :page-size-opts=pageSizeAry>{{ getTranslation('c010')
          }} {{ total }}
                    {{ getTranslation('c011') }}
                </Page>
            </div>
        </template>
        <MachineEdit v-model="modalVisible" :propVisible="modalVisible" :editId="editId" :isCopy="isCopy" @refresh-page="refreshPage">
        </MachineEdit>
        <MachineBackup v-model="backupVisible" :propVisible="backupVisible" :selectedItems="selectedItems" @backup-start="handleStartBackup">
        </MachineBackup>
        <MachineUpgrade v-model="upgradeVisible" :propVisible="upgradeVisible" :selectedItems="selectedItems" @start-upgrade="handleStartUpgrade">
        </MachineUpgrade>

        <MachineRevert v-model="revertVisible" :propVisible="revertVisible" :selectedItems="selectedItems" @start-revert="handleRevert">
        </MachineRevert>

        <Modal v-model="errDialog" @on-ok="closeErr" :cancel-text="''" @on-cancel="closeErr" :okText="getTranslation('m063')" :cancelText="getTranslation('b182')" :title="errTitle" width="50">
            <div v-html="errContent"></div>
        </Modal>
        <MachineCol v-model="colShowVisible" :propVisible="colShowVisible" @machine-col-change="initCol"></MachineCol>
    </div>
</MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue'
import {
    API_URL,
    PAGE_SIZE_ARY
} from '@/constants/const.js'
import axios from 'axios';
import {
    Page,
    Row,
    Col,
    Button,
    Select,
    Option,
    Input,
    Upload,
    Modal,
    Checkbox,
    CheckboxGroup,
    Progress,
    Icon,
    Affix,
    Tooltip
} from 'view-design';
import MachineEdit from './components/MachineEdit.vue';
import MachineBackup from './components/MachineBackup.vue';
import MachineUpgrade from './components/MachineUpgrade.vue';
import MachineRevert from './components/MachineRevert.vue';
import MachineCol from './components/MachineCol.vue';
import {
    mapGetters
} from 'vuex'
import {
    exportFile,
    blobToString,
    postJsError,
    KindOf803Series
} from '@/util/util.js'
import NoAuth from '@/components/NoAuth.vue'
import WebSocket from '@/components/WebSocket.vue'
export default {
    name: 'MachineIndex', // 组件名称
    components: {
        MainLayout,
        Page,
        Row,
        Col,
        Button,
        MachineEdit,
        Select,
        Option,
        Input,
        Upload,
        Modal,
        NoAuth,
        Checkbox,
        CheckboxGroup,
        MachineBackup,
        WebSocket,
        Progress,
        MachineUpgrade,
        MachineRevert,
        Icon,
        Affix,
        Tooltip,
        MachineCol
    },
    props: {

    },
    data() {
        return {
            machine: [],
            productline: [], //所有
            total: 0,
            pageSizeAry: PAGE_SIZE_ARY,
            current: 1,
            pageSize: parseInt(localStorage.getItem('user.page_size')) || 20,
            modalVisible: false,
            editId: 0,
            selectProductline: 0,
            selectState: -1,
            kw: '',
            errDialog: false,
            errContent: '',
            hasAuth: true,
            selectedItems: [],
            backupVisible: false,
            showProgress: false,
            progressJson: null,
            upgradeVisible: false,
            controllerSwVersion: '',
            upgrading: false,
            backuping: false,
            backupJson: null,
            upgradeJson: null,
            listOfProgress: [],
            listOfBackupProgress: [],
            fileList: [],
            canceling: false,
            backupCanceling: false,
            selectParams: '',
            revertVisible: false,
            paramyType: 'backup', //backup or revert 备份/还原共用一个组件
            sortKey: '', // 当前排序字段
            sortOrder: 'asc', // asc | desc
            isCopy: false,
            machineWarning: "",
            colShowVisible: false,
            showColKeys: [],
            colWidths: {}, // 存储列宽
            resizingCol: null, // 当前正在调整大小的列
            downloaOnce: {},
            upgradeProgressChart: null,
            backupProgressChart: null,
        }
    },
    watch: {
        upgrading(val) {
            if (val) {
                this.$nextTick(() => {
                    this.renderUpgradeProgressChart();
                });
                return;
            }
            this.disposeUpgradeProgressChart();
        },
        upgradeJson: {
            handler() {
                if (!this.upgrading) {
                    return;
                }
                this.$nextTick(() => {
                    this.renderUpgradeProgressChart();
                });
            },
            deep: true
        },
        backuping(val) {
            if (val) {
                this.$nextTick(() => {
                    this.renderBackupProgressChart();
                });
                return;
            }
            this.disposeBackupProgressChart();
        },
        backupJson: {
            handler() {
                if (!this.backuping) {
                    return;
                }
                this.$nextTick(() => {
                    this.renderBackupProgressChart();
                });
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        stateMap() {
            return {
                0: this.getTranslation("m036"),
                1: this.getTranslation("m035"),
                2: this.getTranslation("m003"),
                3: this.getTranslation("m004"),
                4: this.getTranslation("m003"),
            }
        },
        mapProductLine() {
            let map = {}
            this.productline && this.productline.forEach((item) => {
                map[item.id] = item.name
            })
            return map
        },
        stateList() {
            return [{
                    value: -1,
                    name: this.getTranslation("m033")
                }, {
                    value: 1,
                    name: this.getTranslation("m035")
                }, {
                    value: 0,
                    name: this.getTranslation("m036")
                },
                {
                    value: 3,
                    name: this.getTranslation("m004")
                }
            ]
        },
        importUrl() {
            return API_URL["machineImportData"];
        },
        errTitle() {
            return this.getTranslation("m062")
        },
        webSocketUrl() {
            return API_URL['webSocket'];
        },
        calUpgradeProgress() {
            if (this.upgrading && this.upgradeJson && this.upgradeJson.planned_total > 0) {
                let percent = Math.floor(((this.upgradeJson.success_count + this.upgradeJson.failed_count) / this.upgradeJson.planned_total) * 100);
                return percent;
            } else {
                return 0;
            }
        },
        calBackupProgress() {
            if (this.backuping && this.backupJson && this.backupJson.planned_total > 0) {
                let percent = Math.floor(((this.backupJson.success_count + this.backupJson.failed_count) / this.backupJson.planned_total) * 100);
                return percent;
            } else {
                return 0;
            }
        },
        calUpgradeSuccess() {
            if (this.upgrading && this.upgradeJson) {
                return this.upgradeJson.success_count;
            } else {
                return 0;
            }
        },
        calBackupSuccess() {
            if (this.backuping && this.backupJson) {
                return this.backupJson.success_count;
            } else {
                return 0;
            }
        },
        calUpgradeFailed() {
            if (this.upgrading && this.upgradeJson && this.upgradeJson.failed_count) {
                return this.upgradeJson.failed_count;
            } else {
                return 0;
            }
        },
        calBackupFailed() {
            if (this.backuping && this.backupJson && this.backupJson.failed_count) {
                return this.backupJson.failed_count;
            } else {
                return 0;
            }
        },
        calUpgradeTotal() {
            if (this.upgrading && this.upgradeJson && this.upgradeJson.planned_total) {
                return this.upgradeJson.planned_total;
            } else {
                return 0;
            }
        },
        calBackupTotal() {
            if (this.backuping && this.backupJson && this.backupJson.planned_total) {
                return this.backupJson.planned_total;
            } else {
                return 0;
            }
        },
        canClose() {
            let rs = false;
            if (this.upgradeJson && (this.upgradeJson.planned_total == (this.upgradeJson.success_count + this.upgradeJson.failed_count))) {
                rs = true;
            }
            return rs
        },
        canBackupClose() {
            let rs = false;
            if (this.backupJson && (this.backupJson.planned_total == (this.backupJson.success_count + this.backupJson.failed_count))) {
                rs = true;
            }
            return rs
        },
        canRetry() {
            let rs = false;
            if (this.upgradeJson && (this.upgradeJson.planned_total == (this.upgradeJson.success_count + this.upgradeJson.failed_count)) && (this.upgradeJson.failed_count > 0)) {
                rs = true;
            }
            return rs
        },
        canBackupRetry() {
            let rs = false;
            if (this.backupJson && (this.backupJson.planned_total == (this.backupJson.success_count + this.backupJson.failed_count)) && (this.backupJson.failed_count > 0)) {
                rs = true;
            }
            return rs
        },
        canCancel() {
            let rs = false;
            if (this.upgradeJson && (this.upgradeJson.planned_total > (this.upgradeJson.success_count + this.upgradeJson.failed_count + 1))) {
                rs = true;
            }
            return rs
        },
        canBackupCancel() {
            let rs = false;
            if (this.backupJson && (this.backupJson.planned_total > (this.backupJson.success_count + this.backupJson.failed_count + 1))) {
                rs = true;
            }
            return rs
        },
        mapStatus() {
            return {
                'waiting': this.getTranslation('m120'),
                'upgrading': this.getTranslation('m116'),
                'success': this.getTranslation('m117'),
                'failed': this.getTranslation('m118'),
            }
        },
        mapBackupStatus() {
            if (this.paramyType == 'backup') {
                return {
                    'waiting': this.getTranslation('m120'),
                    'backuping': this.getTranslation('m166'),
                    'success': this.getTranslation('m167'),
                    'failed': this.getTranslation('m168'),
                }
            } else if (this.paramyType == 'revert') {
                return {
                    'waiting': this.getTranslation('m120'),
                    'backuping': this.getTranslation('m184'),
                    'success': this.getTranslation('m185'),
                    'failed': this.getTranslation('m186'),
                }
            } else {
                return {
                    'waiting': this.getTranslation('m120'),
                    'backuping': this.getTranslation('d038'),
                    'success': this.getTranslation('d034'),
                    'failed': this.getTranslation('d039'),
                }
            }
        },
        safeMachineWarning() {
            if (!this.machineWarning) {
                return '';
            }
            // Keep only line breaks from backend and escape all other markup to avoid DOM/style injection.
            const withNewLine = String(this.machineWarning).replace(/<br\s*\/?\s*>/ig, '\n');
            const escaped = withNewLine
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
            return escaped.replace(/\n/g, '<br />');
        }

    },
    mounted() {

    },
    created() {
        this.setBreadcrumbItems();
        this.getProductLine();
        this.getData();
        this.getWarning();
        this.initCol();
        this.$nextTick(() => {
            // initialize saved widths first, then collect header widths once
            this.loadColWidths();
            this.initHeaderWidths();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleUpgradeProgressResize);
        window.removeEventListener('resize', this.handleBackupProgressResize);
        this.disposeUpgradeProgressChart();
        this.disposeBackupProgressChart();
    },
    methods: {
        renderUpgradeProgressChart() {
            if (!this.$refs.upgradeProgressChart || !this.$echarts) {
                return;
            }
            if (!this.upgradeProgressChart) {
                this.upgradeProgressChart = this.$echarts.init(this.$refs.upgradeProgressChart);
                window.addEventListener('resize', this.handleUpgradeProgressResize);
            }

            const total = this.calUpgradeTotal;
            const success = this.calUpgradeSuccess;
            const failed = this.calUpgradeFailed;
            const pending = Math.max(0, total - success - failed);
            const isEmpty = total <= 0;
            const pieData = isEmpty ? [{
                name: this.getTranslation('m124'),
                value: 1,
                itemStyle: {
                    color: '#d9d9d9'
                }
            }] : [{
                    name: this.getTranslation('m122'),
                    value: success,
                    itemStyle: {
                        color: '#1890ff'
                    }
                },
                {
                    name: this.getTranslation('m123'),
                    value: failed,
                    itemStyle: {
                        color: '#f5222d'
                    }
                },
                {
                    name: this.getTranslation('m124'),
                    value: pending,
                    itemStyle: {
                        color: '#d9d9d9'
                    }
                }
            ];
            
            let centerText = isEmpty ? this.getTranslation('m124') : `${this.calUpgradeProgress}%`;            
            this.upgradeProgressChart.setOption({
                tooltip: {
                    trigger: 'item'
                },
                series: [{
                    type: 'pie',
                    radius: ['72%', '88%'],
                    avoidLabelOverlap: true,
                    label: {
                        show: false
                    },
                    data: pieData
                }],
                graphic: [{
                    type: 'text',
                    left: 'center',
                    top: 'center',
                    style: {
                        text: centerText,
                        textAlign: 'center',
                        fill: '#1890ff',
                        fontSize: 18,
                        fontWeight: 600
                    }
                }]
            }, true);
        },
        handleUpgradeProgressResize() {
            if (this.upgradeProgressChart) {
                this.upgradeProgressChart.resize();
            }
        },
        disposeUpgradeProgressChart() {
            if (this.upgradeProgressChart) {
                this.upgradeProgressChart.dispose();
                this.upgradeProgressChart = null;
            }
        },
        renderBackupProgressChart() {
            if (!this.$refs.backupProgressChart || !this.$echarts) {
                return;
            }
            if (!this.backupProgressChart) {
                this.backupProgressChart = this.$echarts.init(this.$refs.backupProgressChart);
                window.addEventListener('resize', this.handleBackupProgressResize);
            }

            const total = this.calBackupTotal;
            const success = this.calBackupSuccess;
            const failed = this.calBackupFailed;
            const pending = Math.max(0, total - success - failed);
            const isEmpty = total <= 0;
            const pieData = isEmpty ? [{
                name: this.getTranslation('m124'),
                value: 1,
                itemStyle: {
                    color: '#d9d9d9'
                }
            }] : [{
                    name: this.getTranslation('m122'),
                    value: success,
                    itemStyle: {
                        color: '#1890ff'
                    }
                },
                {
                    name: this.getTranslation('m123'),
                    value: failed,
                    itemStyle: {
                        color: '#f5222d'
                    }
                },
                {
                    name: this.getTranslation('m124'),
                    value: pending,
                    itemStyle: {
                        color: '#d9d9d9'
                    }
                }
            ];

            let centerText = isEmpty ? this.getTranslation('m124') : `${this.calBackupProgress}%`;
            this.backupProgressChart.setOption({
                tooltip: {
                    trigger: 'item'
                },
                series: [{
                    type: 'pie',
                    radius: ['72%', '88%'],
                    avoidLabelOverlap: true,
                    label: {
                        show: false
                    },
                    data: pieData
                }],
                graphic: [{
                    type: 'text',
                    left: 'center',
                    top: 'center',
                    style: {
                        text: centerText,
                        textAlign: 'center',
                        fill: '#1890ff',
                        fontSize: 18,
                        fontWeight: 600
                    }
                }]
            }, true);
        },
        handleBackupProgressResize() {
            if (this.backupProgressChart) {
                this.backupProgressChart.resize();
            }
        },
        disposeBackupProgressChart() {
            if (this.backupProgressChart) {
                this.backupProgressChart.dispose();
                this.backupProgressChart = null;
            }
        },
        getData() {
            let url = API_URL["machineGet"];
            let params = {
                page: this.current,
                page_size: this.pageSize
            }
            params.pl_id = this.selectProductline;
            params.state = this.selectState;
            params.kw = this.kw;
            params.controller_sw_ver = this.controllerSwVersion;
            // 排序参数
            if (this.sortKey) {
                params.sort_key = this.sortKey;
                params.sort_order = this.sortOrder;
            }
            axios.get(url, {
                    params
                },{ timeout: 300000 })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.machine = res.data.data.data;
                        this.total = res.data.data.total;
                        this.pageSize = res.data.data.pagination.page_size;
                        this.current = res.data.data.pagination.page;
                    } else if (res && res.data && res.data.code == 3001) {
                        this.hasAuth = false;
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    } else {
                        this.$Message.error(this.getTranslation('m041'));
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        getWarning() {
            let url = API_URL["machineGetWarning"];
            axios.get(url,{timeout:300000})
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.machineWarning = res.data.data.warning || "";
                    }
                })
                .catch((err) => {
                    postJsError(err)
                })
        },
        async getProductLine() {
            let url = API_URL["productlineGetAll"];
            let response = await axios.get(url,{timeout:300000});
            if (response && response.data && response.data.code == 200) {
                this.productline = response.data.data
                this.productline && (this.productline = this.productline.filter(item => item.state == 0));
            } else {
                this.$Message.error(this.getTranslation('p013'));
            }
        },
        handlePageChange(page) {
            this.current = page;
            this.getData();
        },
        handlePageSizeChange(pageSize) {
            this.current = 1;
            this.pageSize = pageSize;
            localStorage.setItem('user.page_size', this.pageSize)
            this.getData();
        },
        add() {
            //0代表新增
            this.isCopy = false;
            this.editId = 0;
            this.modalVisible = true
        },
        edit(id) {
            //0代表新增 
            this.isCopy = false;
            this.editId = id;
            this.modalVisible = true
        },
        copy(id) {
            //0代表新增
            this.isCopy = true;
            this.editId = id;
            this.modalVisible = true
        },
        del(id) {
            let url = API_URL["machineDelete"];
            let params = {
                id: id,
            }
            axios.get(url, {
                    params: params
                })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.$Message.success(this.getTranslation('m039'));
                        this.getData();
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    } else {
                        this.$Message.error(this.getTranslation('c001'));
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        realDel(id) {
            let url = API_URL["machineRealDelete"];
            let params = {
                id: id,
            }
            this.$Modal.confirm({
                title: this.getTranslation('b135'),
                okText: this.getTranslation('b181'),
                cancelText: this.getTranslation('b182'),
                content: this.getTranslation('i033'),
                onOk: async () => {
                    axios.get(url, {
                            params: params
                        })
                        .then(res => {
                            if (res && res.data && res.data.code == 200) {
                                this.$Message.success(res.data.msg);
                                this.getData();
                            } else if (res && res.data && res.data.msg) {
                                this.$Message.error(res.data.msg);
                            } else {
                                this.$Message.error(this.getTranslation('c001'));
                            }
                        })
                        .catch((err) => {
                            postJsError(err)
                            this.$Message.error(this.getTranslation('c001'));
                        })

                }
            });

        },
        recovery(id) {
            let url = API_URL["machineRecover"];
            let params = {
                id: id,
            }
            axios.get(url, {
                    params: params
                })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.$Message.success(this.getTranslation('m040'));
                        this.getData();
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    } else {
                        this.$Message.error(this.getTranslation('c001'));
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        refreshPage() {
            this.getData();
        },
        search() {
            this.current = 1;
            this.getData();
        },
        successImport(response) {
            if (response && response.code == 200) {
                this.$Message.success(response.msg);
                this.getProductLine();
                this.getData();
            } else if (response && response.msg) {
                this.errDialog = true;
                this.errContent = response.msg.replace(/\n/g, '<br>');
            }
        },
        closeErr() {

        },
        errorImport() {
            this.$Message.error(this.getTranslation('c001'));
        },
        async exportData() {
            let exportUrl = API_URL["machineExportData"];
            const response = await axios.get(exportUrl, {
                responseType: 'blob',
                timeout: 300000,
            });
            if (response.status == 200) {
                const contentType = response.headers['content-type'];
                if (contentType && contentType.includes('application/json')) {
                    blobToString(response.data).then(text => {
                        let msgData = JSON.parse(text);
                        if (msgData.msg) {
                            this.$Message.error(msgData.msg)
                        }
                    }).catch((err) => {
                        postJsError(err)
                        this.$Message.error(this.getTranslation('c001'));
                    });
                } else {
                    exportFile(response)
                }
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },
        setBreadcrumbItems() {
            if (this.$lang && this.$lang['u048']) {
                this.$store.commit('setBreadcrumbItems', [{
                    title: this.getTranslation('u048')
                }])
            }
        },
        handleCheckAll(status) {
            if (status) {
                this.selectedItems = this.machine && this.machine.map(item => item.id);
            } else {
                this.selectedItems = [];
            }
        },
        backup() {
            this.backupVisible = true;
        },
        revert() {
            this.revertVisible = true;
        },
        upgrade() {
            if (this.selectedItems.length == 0) {
                this.$Message.warning(this.getTranslation('m094'));
                return;
            }
            this.upgradeVisible = true;
        },
        handleStartBackup(params) {
            this.paramyType = 'backup'
            this.backupCanceling = false
            this.disposeBackupProgressChart();
            this.backupJson = null;
            this.listOfBackupProgress = [];
            this.backuping = true;
            this.selectParams = params;
        },
        handleRevert(params) {
            this.paramyType = 'revert'
            this.backupCanceling = false
            this.disposeBackupProgressChart();
            this.backupJson = null;
            this.listOfBackupProgress = [];
            this.backuping = true;
            this.fileList = params;
        },
        receiveMessage(obj) {
            if (obj && obj.kind) {
                switch (obj.kind) {
                    case 'notice':
                        var dat = obj.data
                        if (dat && dat.msg) {
                            this.$Message.info(dat.msg);
                        }
                        break;
                    case 'upgradeProgress':
                        if (obj.data) {
                            this.upgrading = true;
                            this.backuping = false;
                            if (!this.upgradeJson || (this.upgradeJson.success_count + this.upgradeJson.failed_count) <= (obj.data.success_count + obj.data.failed_count)) {
                                this.upgradeJson = obj.data;

                                // 将 device_progress 转换为数组并排序：seq 升序，mac_id 降序
                                const deviceProgressObj = obj.data.device_progress || {};
                                const progressArray = Array.isArray(deviceProgressObj) ?
                                    deviceProgressObj :
                                    Object.values(deviceProgressObj);

                                this.listOfProgress = progressArray.sort((a, b) => {
                                    if (a.seq !== b.seq) {
                                        return a.seq - b.seq;
                                    }
                                    return b.mac_id - a.mac_id;
                                });
                            }
                        }
                        break;
                    case 'backupProgress':
                        if (obj.data) {
                            this.upgrading = false;
                            this.backuping = true;
                            if (!this.backupJson || (this.backupJson.success_count + this.backupJson.failed_count) <= (obj.data.success_count + obj.data.failed_count)) {
                                this.backupJson = obj.data;
                                this.paramyType = obj.data.param_type || 'backup'
                                // 将 device_progress 转换为数组并排序：seq 升序，mac_id 降序
                                const deviceProgressObj = obj.data.device_progress || {};
                                const progressArray = Array.isArray(deviceProgressObj) ?
                                    deviceProgressObj :
                                    Object.values(deviceProgressObj);
                                //自动下载
                                if (obj.data.param_type == 'backup' && this.backupJson &&
                                    (this.backupJson.planned_total == (this.backupJson.success_count + this.backupJson.failed_count)) &&
                                    this.backupJson.success_count > 0 && this.backupJson.param_file_path &&
                                    !this.downloaOnce[this.backupJson.param_file_path]
                                ) {
                                    this.autoDownloadBackupFile(this.backupJson.param_file_path)
                                    this.downloaOnce[this.backupJson.param_file_path] = true;
                                }

                                this.listOfBackupProgress = progressArray.sort((a, b) => {
                                    if (a.seq !== b.seq) {
                                        return a.seq - b.seq;
                                    }
                                    return b.mac_id - a.mac_id;
                                });
                            }
                        }
                        break;
                    default:
                        break;
                }
            }
        },
        async autoDownloadBackupFile(selectedBackup) {
            let url = API_URL["machineDownloadBackup"];
            let params = {
                lot: selectedBackup
            };
            const response = await axios.get(url, {
                params: params,
                responseType: 'blob',
                timeout:300000,
            });
            if (response.status == 200) {
                const contentType = response.headers['content-type'];
                if (contentType && contentType.includes('application/json')) {
                    blobToString(response.data).then(text => {
                        let msgData = JSON.parse(text);
                        if (msgData.msg) {
                            this.$Message.error(msgData.msg)
                            this.modalLoading = false;
                            this.resetModal();
                        }
                    }).catch((err) => {
                        this.modalLoading = false;
                        this.resetModal();
                        postJsError(err)
                        this.$Message.error(this.getTranslation('c001'));
                    });
                } else {
                    exportFile(response)
                    this.visible = false
                }
            } else {
                this.$Message.error(this.getTranslation('c001'));
                this.modalLoading = false;
                this.resetModal();
            }
        },
        handleStartUpgrade(fileList) {
            this.fileList = fileList;
            this.canceling = false

            this.disposeUpgradeProgressChart();
            this.upgradeJson = null;
            this.listOfProgress = [];
            this.upgrading = true;
        },
        calOnePercent(oneProgress) {

            if (oneProgress && oneProgress.total > 0) {

                let percent = Math.floor((oneProgress.processed / oneProgress.total) * 100);

                return percent;
            } else {
                return 0;
            }
        },
        getStatusClass(status) {
            if (!status) return 'pending';
            const statusStr = status.toLowerCase();
            if (statusStr.includes('success')) {
                return 'success';
            } else if (statusStr.includes('failed') || statusStr.includes('error')) {
                return 'failed';
            } else if (statusStr.includes('upgrading') || statusStr.includes('processing')) {
                return 'upgrading';
            } else if (statusStr.includes('backuping') || statusStr.includes('processing')) {
                return 'backuping';
            } else {
                return 'pending';
            }
        },
        getBackupStatusClass(status) {
            if (!status) return 'pending';
            const statusStr = status.toLowerCase();
            if (statusStr.includes('success')) {
                return 'success';
            } else if (statusStr.includes('failed') || statusStr.includes('error')) {
                return 'failed';
            } else if (statusStr.includes('backuping') || statusStr.includes('processing')) {
                return 'backuping';
            } else {
                return 'pending';
            }
        },
        getProgressColor(status) {
            const statusClass = this.getStatusClass(status);
            switch (statusClass) {
                case 'success':
                    return '#52c41a';
                case 'failed':
                    return '#f5222d';
                case 'upgrading':
                    return '#1890ff';
                case 'backuping':
                    return '#1890ff';
                default:
                    return '#515a6e';
            }
        },
        getProgressStatus(status) {
            const statusClass = this.getStatusClass(status);
            switch (statusClass) {
                case 'success':
                    return 'success';
                case 'failed':
                    return 'wrong';
                case 'upgrading':
                    return 'active';
                case 'backuping':
                    return 'active';
                default:
                    return 'normal';
            }
        },
        async retry() {
            if (this.fileList.length == 0) {
                this.$Message.error(this.getTranslation('m126'));
                return;
            }
            this.canceling = false
            this.disposeUpgradeProgressChart();
            this.upgradeJson = null;
            this.listOfProgress = [];
            this.upgrading = true;
            const url = API_URL["machineSoftwareUpgradeRetry"];
            const formData = new FormData();
            formData.append('file', this.fileList[0]);
            const res = await axios.post(url,
                formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).catch((err) => {
                postJsError(err)
                this.$Message.error(this.getTranslation('c001'));
            })
            if (res && res.data && res.data.code == 200) {
                this.upgradeVisible = false;
                this.upgradeJson = null;
                this.listOfProgress = [];
                this.upgrading = true;
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },
        async retryBackup() {
            this.backupCanceling = false
            this.disposeBackupProgressChart();
            this.backupJson = null;
            this.backupListOfProgress = [];
            this.backuping = true;
            const formData = new FormData();
            let url = API_URL["machineBackupRetry"];
            if (this.paramyType == 'revert') {
                url = API_URL["machineRevertRetry"];
                if (this.fileList.length == 0) {
                    this.$Message.error(this.getTranslation('m176'));
                    return;
                }
                formData.append('file', this.fileList[0]);
            } else if (this.paramyType == 'spotRefresh') {
                url = API_URL["machineSpotRefreshRetry"];
            }
            formData.append('backupParams', this.selectParams);
            const res = await axios.post(url,
                formData, {
                    timeout: 300000
                }
            ).catch((err) => {
                postJsError(err)
                this.$Message.error(this.getTranslation('c001'));
            })
            if (res && res.data && res.data.code == 200) {
                this.backupVisible = false;
                this.backupJson = null;
                this.backupListOfProgress = [];
                this.backuping = true;
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },
        async cancel() {
            this.$Modal.confirm({
                title: this.getTranslation('b135'),
                okText: this.getTranslation('b181'),
                cancelText: this.getTranslation('b182'),
                content: this.getTranslation('m130'),
                onOk: async () => {
                    const url = API_URL["machineSoftwareUpgradeCancel"];
                    const formData = new FormData();
                    const res = await axios.post(url,
                        formData, {}
                    ).catch((err) => {
                        postJsError(err)
                        this.$Message.error(this.getTranslation('c001'));
                    })
                    if (res && res.data && res.data.code == 200) {
                        this.canceling = true;
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    } else {
                        this.$Message.error(this.getTranslation('c001'));
                    }
                }
            });

        },
        async cancelBackup() {
            let contentMsg = this.getTranslation('m177');
            if (this.paramyType == 'revert') {
                contentMsg = this.getTranslation('m194');
            } else if (this.paramyType == 'spotRefresh') {
                contentMsg = this.getTranslation('d040');
            }
            this.$Modal.confirm({
                title: this.getTranslation('b135'),
                okText: this.getTranslation('b181'),
                cancelText: this.getTranslation('b182'),
                content: contentMsg,
                onOk: async () => {
                    const url = API_URL["machineBackupCancel"];
                    const formData = new FormData();
                    const res = await axios.post(url,
                        formData, {}
                    ).catch((err) => {
                        postJsError(err)
                        this.$Message.error(this.getTranslation('c001'));
                    })
                    if (res && res.data && res.data.code == 200) {
                        this.backupCanceling = true;
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    } else {
                        this.$Message.error(this.getTranslation('c001'));
                    }
                }
            });

        },
        closeBackup() {

            this.disposeBackupProgressChart();
            this.backuping = false
        },
        switchCheckbox(item) {
            this.selectedItems && this.selectedItems.includes(item.id) ? this.selectedItems = this.selectedItems.filter(id => id !== item.id) : this.selectedItems.push(item.id);
        },
        toggleSort(key) {
            if (this.sortKey === key) {
                this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortKey = key;
                this.sortOrder = 'asc';
            }
            this.current = 1;
            this.getData();
        },
        emptyQuery() {
            this.selectProductline = 0;
            this.selectState = -1;
            this.kw = '';
            this.controllerSwVersion = '';
            this.sortKey = '';
            this.sortOrder = 'asc';
            this.current = 1;
            this.getData();
        },
        spotRefresh() {
            if (this.selectedItems.length == 0) {
                this.$Message.warning(this.getTranslation('m094'));
                return;
            }
            let contentMsg = this.getTranslation('d030')
            this.$Modal.confirm({
                title: this.getTranslation('b135'),
                okText: this.getTranslation('b181'),
                cancelText: this.getTranslation('b182'),
                content: contentMsg,
                onOk: async () => {
                    const formData = new FormData();
                    let url = API_URL["machineSpotRefresh"];
                    formData.append('ids', this.selectedItems.join(','));
                    const res = await axios.post(url,
                        formData, {}
                    ).catch((err) => {
                        postJsError(err)
                        this.$Message.error(this.getTranslation('c001'));
                    })
                    if (res && res.data && res.data.code == 200) {
                        this.backuping = true;
                        this.paramyType = 'spotRefresh'
                        this.disposeBackupProgressChart();
                        this.backupJson = null;
                        this.listOfBackupProgress = [];
                        this.backupCanceling = false;
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    } else {
                        this.$Message.error(this.getTranslation('c001'));
                    }
                }
            });

        },
        async exportWarning() {
            let exportUrl = API_URL["machineExportWarning"];
            const response = await axios.get(exportUrl, {
                responseType: 'blob',
                timeout: 300000,
            }).catch((err) => {
                postJsError(err)
                this.$Message.error(this.getTranslation('c001'));
            });

            if (response.status == 200) {
                const contentType = response.headers['content-type'];
                if (contentType && contentType.includes('application/json')) {
                    blobToString(response.data).then(text => {
                        let msgData = JSON.parse(text);
                        if (msgData.msg) {
                            this.$Message.error(msgData.msg)
                        }
                    }).catch((err) => {
                        postJsError(err)
                        this.$Message.error(this.getTranslation('c001'));
                    });
                } else {
                    exportFile(response)
                }
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }

        },
        initCol() {
            const raw = localStorage.getItem('machine.showCols');
            if (raw) {
                try {
                    const parsed = JSON.parse(raw);
                    if (Array.isArray(parsed)) {
                        this.showColKeys = parsed.map(v => String(v));
                        return;
                    }
                    // Backward compatibility: tolerate legacy object format like {"1": true}
                    if (parsed && typeof parsed === 'object') {
                        this.showColKeys = Object.keys(parsed).filter(k => !!parsed[k]).map(v => String(v));
                        return;
                    }
                } catch (_) {
                    console.log(_)
                }
            }
            this.showColKeys = [];
        },
        initHeaderWidths() {
            for (let i = 1; i <= 13; i++) {
                const key = String(i);
                if (!this.colWidths[key]) {
                    const ref = this.$refs[`col-ref-${key}`];
                    if (ref && ref.$el) {
                        this.$set(this.colWidths, key, ref.$el.clientWidth);
                    }
                }
            }
        },
        showCol(key) {
            if (!Array.isArray(this.showColKeys) || this.showColKeys.length == 0) {
                return true;
            }
            return this.showColKeys.includes(String(key));
        },
        colStyle(key) {
            const w = this.getColWidth(key);
            const basis = w || 100;
            const isLast = key === '13';
            const style = {
                flex: isLast ? `0 0 ${basis}px` : `1 1 ${basis}px`,
                minWidth: '30px',
                position: 'relative'
            };

            if (isLast) style.marginLeft = 'auto';
            return style;
        },
        getColWidth(key) {
            // pure: do not mutate reactive state inside render
            const ref = this.$refs[`col-ref-${key}`];
            const current = this.colWidths[key];
            return current || (ref && ref.$el ? ref.$el.clientWidth : '');
        },
        startResize(key, e) {
            const startX = e.clientX;
            const startWidth = this.getColWidth(key);

            this.resizing = {
                key,
                startX,
                startWidth
            };
            window.addEventListener('mousemove', this.onResizeMouseMove);
            window.addEventListener('mouseup', this.stopResizeMouseMove);
            e.preventDefault();
        },
        onResizeMouseMove(e) {
            if (!this.resizing) return;
            const delta = e.clientX - this.resizing.startX;
            const newWidth = Math.max(30, this.resizing.startWidth + delta);
            this.$set(this.colWidths, this.resizing.key, newWidth);
        },
        stopResizeMouseMove() {
            if (!this.resizing) return;
            window.removeEventListener('mousemove', this.onResizeMouseMove);
            window.removeEventListener('mouseup', this.stopResizeMouseMove);
            this.saveColWidths();
            this.resizing = null;
        },
        loadColWidths() {
            try {
                const raw = localStorage.getItem('machine.colWidths');
                if (raw) {
                    const parsed = JSON.parse(raw);

                    this.colWidths = {
                        ...this.colWidths,
                        ...parsed
                    };
                }
            } catch (_) {
                console.log(_)
            }
        },
        saveColWidths() {
            try {

                localStorage.setItem('machine.colWidths', JSON.stringify(this.colWidths));
            } catch (_) {
                console.log(_)
            }
        },
        online(id) {
            let url = API_URL["machineOnline"];
            let params = {
                id: id
            }
            axios.get(url, {
                    params: params
                })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.$Message.success(res.data.msg);
                        this.setMachineState(id, 1);
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    } else {
                        this.$Message.error(this.getTranslation('c001'));
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        offline(id) {
            let url = API_URL["machineOffline"];
            let params = {
                id: id
            }
            axios.get(url, {
                    params: params
                })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.$Message.success(res.data.msg);
                        this.setMachineState(id, 0);
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    } else {
                        this.$Message.error(this.getTranslation('c001'));
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })

        },
        setMachineState(id, state) {
            const machine = this.machine.find(m => String(m.id) === String(id));
            if (machine) {
                this.$set(machine, 'state', state);
            }
        },
        KindOf803Series(kind){
            return KindOf803Series(kind)
        }
    }

}
</script>

<style>
.hide-label.ivu-checkbox-wrapper>span:last-child {
    display: none;
}

.online {
    background-color: #39ff14;
}

.sortable {
    cursor: pointer;
    user-select: none;
}

.sort-icon {
    margin-left: 6px;
    font-size: 14px;
    vertical-align: middle;
    color: #808695;
}
</style><style scoped>
@import url("../../assets/style/list.css");

/* 升级进度容器样式 */
.upgrade-progress-container {
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;
    margin: 20px 0;
}

/* 总体进度区域 */
.overall-progress-section {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    overflow: hidden;
}

.progress-header {
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
    background: #f8f9fa;
}

.progress-title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #495057;
}

.progress-content {
    padding: 20px;
}

.main-progress {
    display: flex;
    align-items: center;
    gap: 40px;
}

.circle-progress {
    flex-shrink: 0;
}

.upgrade-progress-pie {
    width: 120px;
    height: 120px;
}

.circle-text {
    font-size: 18px;
    font-weight: bold;
    color: #1890ff;
}

.progress-stats {
    flex: 1;
}

.progress-content-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.stats-row {
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 12px 0;
}

.stat-item {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
}

.stat-label {
    font-size: 14px;
    color: #6c757d;
    font-weight: 500;
}

.stat-value {
    font-size: 16px;
    font-weight: bold;
}

.stat-value.total {
    color: #17a2b8;
}

.stat-value.success {
    color: #28a745;
}

.stat-value.failed {
    color: #dc3545;
}

.stat-value.processing {
    color: #ffc107;
}

.button-row {
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: center;
    padding: 8px 0;
}

/* 设备进度区域 */
.device-progress-section {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.device-header {
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
    background: #f8f9fa;
}

.device-title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #495057;
}

.device-list {
    padding: 16px;
}

.device-item {
    border: 1px solid #e9ecef;
    border-radius: 6px;
    padding: 12px 16px;
    margin-bottom: 8px;
    background: white;
    transition: all 0.2s ease;
}

.device-item:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.device-item:last-child {
    margin-bottom: 0;
}

.device-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.device-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
}

.device-name {
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #495057;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.device-icon {
    margin-right: 6px;
    font-size: 14px;
    flex-shrink: 0;
}

.device-status {
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 11px;
    font-weight: 500;
    white-space: nowrap;
    flex-shrink: 0;
}

.device-status.success {
    background: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
}

.device-status.failed {
    background: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
}

.device-status.upgrading {
    background: #e6f7ff;
    color: #096dd9;
    border: 1px solid #91d5ff;
}

.device-status.backuping {
    background: #e6f7ff;
    color: #096dd9;
    border: 1px solid #91d5ff;
}

.device-status.pending {
    background: #e2e3e5;
    color: #383d41;
    border: 1px solid #d6d8db;
}

.device-progress-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
    min-width: 120px;
}

.progress-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex-shrink: 0;
}

.progress-bar {
    width: 200px;
    flex-shrink: 0;
}

.progress-count {
    font-size: 11px;
    color: #6c757d;
    font-weight: 500;
    white-space: nowrap;
    flex-shrink: 0;
}

.device-error {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px dashed #f0f0f0;
}

.error-message {
    display: flex;
    align-items: center;
    padding: 6px 8px;
    background: #f8d7da;
    border: 1px solid #f5c6cb;
    border-radius: 3px;
    font-size: 11px;
    color: #721c24;
}

.error-icon {
    margin-right: 4px;
    font-size: 12px;
    flex-shrink: 0;
}

/* 取消状态样式 */
.canceling-status {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 6px;
    background: #fff7e6;
    border: 1px solid #ffd591;
    border-radius: 6px;
    color: #fa8c16;
    font-size: 14px;
    font-weight: 500;
    animation: canceling-pulse 2s ease-in-out infinite;
}

.canceling-spinner {
    position: relative;
    width: 14px;
    height: 14px;
}

.spinner-circle {
    width: 14px;
    height: 14px;
    border: 2px solid #fa8c16;
    border-top: 2px solid transparent;
    border-radius: 50%;
    animation: canceling-spin 1s linear infinite;
}

.canceling-text {
    font-weight: 500;
}

@keyframes canceling-spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@keyframes canceling-pulse {

    0%,
    100% {
        box-shadow: 0 0 0 0 rgba(250, 140, 22, 0.4);
    }

    50% {
        box-shadow: 0 0 0 4px rgba(250, 140, 22, 0.1);
    }
}

/* 操作组样式 */
.action-groups {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
}

.action-group {
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    padding: 8px 12px;
    background-color: #fafafa;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.action-group legend {
    margin: 0;
    padding: 0;
    border: none;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0;
}

.action-group legend .ivu-btn {
    margin: 0;
}

.sort-img {
    width: 12px;
    vertical-align: middle;
    margin-left: 4px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .main-progress {
        flex-direction: column;
        gap: 20px;
    }

    .progress-content-right {
        width: 100%;
    }

    .progress-stats {
        width: 100%;
    }

    .stats-row {
        flex-wrap: wrap;
        gap: 16px;
        justify-content: space-between;
    }

    .stat-item {
        flex: 1;
        min-width: 45%;
        justify-content: space-between;
    }

    .button-row {
        justify-content: center;
    }

    .device-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    .device-info {
        width: 100%;
        justify-content: space-between;
    }

    .device-progress-info {
        width: 100%;
        justify-content: space-between;
    }

    .progress-bar {
        width: 120px;
    }

}

.machine-warning {
    font-size: 12px;
    color: #fa8c16;
    background-color: #fff7e6;
    padding: 2px 12px;
    border-radius: 6px;
}

.col-resizer {
    position: absolute;
    right: 0px;
    top: 0;
    height: 100%;
    width: 1px;
    cursor: col-resize;
    user-select: none;
    /* subtle visual cue */
    background: rgba(0, 0, 0, 0.1);
}
</style>
